import { Service, signal } from '@angular/core';

// Shared signal store for the active user identity.
@Service()
export class UserContext {
  readonly activeUser = signal<string>('Anonymous User');
}
